import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';
import { useState } from 'react';
import DemoBookingModal from '../../components/feature/DemoBookingModal';

export default function BenefitsPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: '核心优势 - 智研云 | 效率提升80% 成本降低60%',
    description: '相比传统人工管理，智研云智能研发费用管理系统效率提升80%，成本降低60%，风险降低90%，客户满意度98%，为企业带来显著的竞争优势。',
    keywords: '研发管理优势,效率提升,成本降低,风险管控,智能管理',
    canonical: '/benefits',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '核心优势',
      url: `${siteUrl}/benefits`,
      description: '智研云相比传统管理方式的核心优势'
    }
  });

  const handleFreeTrial = () => {
    window.open('http://112.74.46.225:8002/admin/login?register=register', '_blank');
  };

  return (
    <>
      <Header />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-purple-50 via-pink-50 to-white py-16 md:py-24 overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://readdy.ai/api/search-image?query=Business%20advantage%20and%20competitive%20edge%20concept%20with%20rising%20graphs%20and%20success%20elements%20in%20soft%20purple%20and%20pink%20gradient%20modern%20professional%20design&width=1920&height=600&seq=benefits-hero-bg&orientation=landscape')] opacity-5 bg-cover bg-center"></div>
          
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
            <div className="text-center max-w-4xl mx-auto">
              <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 px-4 sm:px-5 py-2 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-6">
                <i className="ri-medal-fill"></i>
                <span>显著的竞争优势</span>
              </div>
              
              <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight px-4">
                选择智研云的<br />
                <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">核心优势</span>
              </h1>
              
              <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed px-4">
                相比传统人工管理方式，智研云为您带来全方位的效率提升和成本节约<br className="hidden sm:block" />
                让研发费用管理变得简单、高效、合规
              </p>
            </div>
          </div>
        </section>

        {/* Comparison Table */}
        <section className="py-12 sm:py-16 lg:py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
            {/* 移动端卡片式布局 */}
            <div className="lg:hidden space-y-6">
              {[
                {
                  title: '整体差异',
                  manual: '依赖人工经验，效率低下，容易出错',
                  system: '智能化管理，自动化处理，精准高效'
                },
                {
                  title: '研发合规管理',
                  manual: '缺乏系统性管理，合规风险高',
                  system: '全流程合规管控，风险实时预警'
                },
                {
                  title: '研发过程资料',
                  manual: '资料分散，整理困难，易丢失',
                  system: '自动归档，云端存储，随时调取'
                },
                {
                  title: '研发工时管理',
                  manual: '手工填报，数据不准确，难以追溯',
                  system: '移动端填报，智能分配，实时统计'
                },
                {
                  title: '多口径报表',
                  manual: '手工制作，耗时长，易出错',
                  system: '一键生成，多维度报表，准确无误'
                },
                {
                  title: '留存备查资料',
                  manual: '人工整理，工作量大，不规范',
                  system: '自动生成，符合政策要求，完整规范'
                },
                {
                  title: '风险预警',
                  manual: '事后发现，补救困难，损失大',
                  system: '实时监控，提前预警，及时处理'
                },
                {
                  title: '人员离职风险',
                  manual: '资料随人走，交接困难，损失大',
                  system: '系统留存，不受人员变动影响'
                }
              ].map((item, index) => (
                <div key={index} className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
                  <div className="bg-gradient-to-r from-teal-500 to-blue-500 px-5 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center bg-white/20 text-white rounded-full font-bold text-sm flex-shrink-0">
                        {index + 1}
                      </div>
                      <h3 className="font-bold text-white text-lg">{item.title}</h3>
                    </div>
                  </div>
                  <div className="p-5 space-y-4">
                    <div className="flex items-start gap-3">
                      <i className="ri-close-circle-fill text-red-500 text-xl flex-shrink-0 mt-0.5"></i>
                      <div>
                        <div className="text-xs text-gray-500 mb-1">人工管理</div>
                        <div className="text-sm text-gray-700">{item.manual}</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-green-500 text-xl flex-shrink-0 mt-0.5"></i>
                      <div>
                        <div className="text-xs text-gray-500 mb-1">智研云</div>
                        <div className="text-sm text-gray-900 font-medium">{item.system}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              
              <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-2xl p-6 border-4 border-teal-500">
                <div className="flex items-start gap-4 mb-4">
                  <i className="ri-trophy-fill text-teal-600 text-3xl flex-shrink-0"></i>
                  <div>
                    <div className="text-xl font-bold text-gray-900 mb-2">智能系统全面领先</div>
                    <div className="text-sm text-gray-600">效率提升80%，成本降低60%，风险降低90%</div>
                  </div>
                </div>
                <button className="bg-gradient-to-r from-teal-600 to-blue-600 text-white px-6 py-3 rounded-xl hover:from-teal-700 hover:to-blue-700 transition-all w-full cursor-pointer whitespace-nowrap font-semibold shadow-md text-sm">
                  立即体验
                </button>
              </div>
            </div>

            {/* PC端表格布局 */}
            <div className="hidden lg:block bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
              <div className="bg-gradient-to-r from-teal-500 to-blue-500 px-8 py-6">
                <div className="grid grid-cols-3 gap-6 items-center">
                  <div className="text-white/80 font-semibold text-lg">对比维度</div>
                  <div className="text-center">
                    <div className="text-white font-bold text-2xl mb-1">人工管理</div>
                    <div className="text-white/80 text-sm">传统方式</div>
                  </div>
                  <div className="text-center">
                    <div className="text-white font-bold text-2xl mb-1">智研云</div>
                    <div className="text-white/80 text-sm">智能系统</div>
                  </div>
                </div>
              </div>

              <div className="divide-y divide-gray-100">
                {[
                  {
                    title: '整体差异',
                    manual: '依赖人工经验，效率低下，容易出错',
                    system: '智能化管理，自动化处理，精准高效'
                  },
                  {
                    title: '研发合规管理',
                    manual: '缺乏系统性管理，合规风险高',
                    system: '全流程合规管控，风险实时预警'
                  },
                  {
                    title: '研发过程资料',
                    manual: '资料分散，整理困难，易丢失',
                    system: '自动归档，云端存储，随时调取'
                  },
                  {
                    title: '研发工时管理',
                    manual: '手工填报，数据不准确，难以追溯',
                    system: '移动端填报，智能分配，实时统计'
                  },
                  {
                    title: '多口径报表',
                    manual: '手工制作，耗时长，易出错',
                    system: '一键生成，多维度报表，准确无误'
                  },
                  {
                    title: '留存备查资料',
                    manual: '人工整理，工作量大，不规范',
                    system: '自动生成，符合政策要求，完整规范'
                  },
                  {
                    title: '风险预警',
                    manual: '事后发现，补救困难，损失大',
                    system: '实时监控，提前预警，及时处理'
                  },
                  {
                    title: '人员离职风险',
                    manual: '资料随人走，交接困难，损失大',
                    system: '系统留存，不受人员变动影响'
                  }
                ].map((item, index) => (
                  <div 
                    key={index}
                    className="grid grid-cols-3 gap-6 px-8 py-6 hover:bg-gradient-to-r hover:from-teal-50/50 hover:to-blue-50/50 transition-all group"
                  >
                    <div className="flex items-center gap-4">
                      <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-teal-500 to-blue-500 text-white rounded-full font-bold text-lg flex-shrink-0">
                        {index + 1}
                      </div>
                      <div className="font-semibold text-gray-900 text-lg">{item.title}</div>
                    </div>
                    <div className="flex items-center gap-3 text-gray-600">
                      <i className="ri-close-circle-fill text-red-500 text-2xl flex-shrink-0"></i>
                      <span>{item.manual}</span>
                    </div>
                    <div className="flex items-center gap-3 text-gray-900">
                      <i className="ri-checkbox-circle-fill text-green-500 text-2xl flex-shrink-0"></i>
                      <span className="font-medium">{item.system}</span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="bg-gradient-to-r from-teal-50 to-blue-50 px-8 py-8 border-t-4 border-teal-500">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <i className="ri-trophy-fill text-teal-600 text-4xl"></i>
                    <div>
                      <div className="text-2xl font-bold text-gray-900 mb-1">智能系统全面领先</div>
                      <div className="text-gray-600">效率提升80%，成本降低60%，风险降低90%</div>
                    </div>
                  </div>
                  <button 
                    onClick={handleFreeTrial}
                    className="bg-gradient-to-r from-teal-600 to-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:from-teal-700 hover:to-blue-700 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
                  >
                    立即体验
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Cards */}
        <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
            <div className="text-center mb-12 sm:mb-16">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-4">
                为您带来的<span className="bg-gradient-to-r from-teal-600 to-blue-600 bg-clip-text text-transparent">实际价值</span>
              </h2>
              <p className="text-base sm:text-lg lg:text-xl text-gray-600 px-4">
                数据来源于1000+企业客户的真实使用反馈
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
              {[
                {
                  icon: 'ri-time-line',
                  value: '80%',
                  label: '效率提升',
                  description: '自动化处理节省大量人工时间',
                  color: 'from-blue-500 to-cyan-500'
                },
                {
                  icon: 'ri-money-dollar-circle-line',
                  value: '60%',
                  label: '成本降低',
                  description: '减少人力投入和错误损失',
                  color: 'from-green-500 to-emerald-500'
                },
                {
                  icon: 'ri-shield-check-line',
                  value: '90%',
                  label: '风险降低',
                  description: '实时预警避免合规问题',
                  color: 'from-purple-500 to-pink-500'
                },
                {
                  icon: 'ri-thumb-up-line',
                  value: '98%',
                  label: '客户满意度',
                  description: '持续获得客户好评推荐',
                  color: 'from-orange-500 to-red-500'
                }
              ].map((benefit, index) => (
                <div 
                  key={index}
                  className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100"
                >
                  <div className={`w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br ${benefit.color} rounded-xl sm:rounded-2xl mb-5 sm:mb-6`}>
                    <i className={`${benefit.icon} text-2xl sm:text-3xl text-white`}></i>
                  </div>
                  <div className={`text-4xl sm:text-5xl font-bold bg-gradient-to-r ${benefit.color} bg-clip-text text-transparent mb-2`}>
                    {benefit.value}
                  </div>
                  <div className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">
                    {benefit.label}
                  </div>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-teal-600 to-blue-600 relative overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://readdy.ai/api/search-image?query=Success%20celebration%20concept%20with%20achievement%20trophy%20and%20winning%20elements%20in%20white%20and%20light%20blue%20modern%20minimalist%20design&width=1920&height=400&seq=benefits-cta-bg&orientation=landscape')] opacity-10 bg-cover bg-center"></div>
          
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center relative z-10">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4 sm:mb-6 px-4">
              立即体验核心优势
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-6 sm:mb-8 px-4">
              加入1000+企业的行列，享受智能化管理带来的便利
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-4">
              <button 
                onClick={handleFreeTrial}
                className="w-full sm:w-auto bg-white text-teal-600 px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer text-sm sm:text-base"
              >
                免费试用
              </button>
              <button 
                onClick={() => setIsDemoModalOpen(true)}
                className="w-full sm:w-auto bg-white/10 backdrop-blur-sm text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer text-sm sm:text-base"
              >
                查看案例
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      
      {/* 预约演示弹窗 */}
      <DemoBookingModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} />
    </>
  );
}
